import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "./SecondaryResourcesCategoryView"
import Prep3TB from "../images/prep-3.jpg"
import ZipLogo from "../images/zip.svg"

class Prep2Resources extends React.Component {
  state = {
    view: {
      title: "Preparatory 3 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Prep3TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G9-Preparatory-3-TB_WM_2022.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-prep3-jan-2022/",
          files: [{ name: "Preparatory 3 Audio", file: "grade-9-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Prep2Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrep3.js